import React from 'react';
import { Helmet } from 'react-helmet';
import * as seoConfig from './SEOConfig';

export interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  keywords?: string[];
  titleTemplate?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'LP Exchange',
  description,
  image = '/static/media/CC_LP_Exchange_Logo_Icon_Where.24453331.svg',
  url = '/',
  keywords = [],
  titleTemplate = `LPX | `,
}) => {
  return (
    <Helmet title={title} titleTemplate={`${titleTemplate} %s`}>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta name="keywords" content={seoConfig.seoDefaultKeyWords.concat(keywords).toString()} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
    </Helmet>
  );
};

export default SEO;
